import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { prodURL } from "../utils/common";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";

const Contact_Us_Home = () => {
  const { t } = useTranslation();
  return (
    <div className="fontSizeClass">
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
          {/* <div className="container">
            
            <div className="section-main-heading2">
              
              <h4 className="fontSizeClass"></h4>
            </div>
          </div> */}
        </div>
      </section>
      {/* End Slider */}
      <section className="section inner-pad1">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu ">
                <nav className="sidebar card py-2 mb-4">
                  <ul className="nav flex-column" id="nav_accordion">
                    <li className="nav-item">
                      <Link
                        className="nav-link active1 fontSizeClass"
                        to="/Contact_Us_Home"
                      >
                        {t("Contact Us Home")}
                      </Link>
                    </li>
                    {/* <li className="nav-item"><Link className="nav-link fontSizeClass" to='/EWaste'> {t("E-Waste")} </Link> </li> */}
                    <li className="nav-item">
                      <a
                        className="nav-link fontSizeClass"
                        href={`${prodURL}/contact-us/importantContacts`}
                      >
                        {t("Important Contacts")}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link fontSizeClass"
                        href={`${prodURL}/contact-us/mmic`}
                      >
                        {t("MMIC")}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link fontSizeClass"
                        href={`${prodURL}/contact-us/controllingOfficers`}
                      >
                        {t("Controlling Officers")}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link fontSizeClass"
                        href={`${prodURL}/contact-us/councillors`}
                      >
                        {t("Councillors")}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link fontSizeClass"
                        href={`${prodURL}/contact-us/boroughCommittee`}
                      >
                        {t("Borough Committee")}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link fontSizeClass"
                        href={`${prodURL}/contact-us/boroughOffices`}
                      >
                        {t("Borough Offices")}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link fontSizeClass"
                        href={`${prodURL}/contact-us/knowYourWard`}
                      >
                        {t("Know Your Ward")}
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2">
                    <h3 className="fontSizeClass"> {t("Contact Us")}: </h3>
                  </div>
                  <div className="col-lg-12 about-head1">
                    <div className="mayor-table2">
                      <table className="table table-bordered">
                        <tbody>
                          <tr>
                            <td>
                              <strong>
                                {t("Kolkata Municipal Corporation")} -
                              </strong>
                              <br />
                              <p className="fontSizeClass">
                                {t(
                                  "KMC_Head_Office"
                                )}
                                <br />
                                {t("Ph")} : +91 33 2286-1000 (28 Lines)
                              </p>
                            </td>
                            <td>
                              <strong> {t("Control Room")} - </strong> <br />
                              <p className="fontSizeClass">
                                {t("Ph")}: +91 33 2286-1212/1313/1414 <br />
                                {/* {t("Fax")} +91 33 2286-1444 */}
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={2}>
                              <strong> {t("Call Centre")} -</strong> <br />
                              <p className="fontSizeClass">
                                KMC Working Days : "Mon-Fri : 10:30 AM to 5:00
                                PM" & "Sat : 10:30 AM to 2:30 PM" <br/> Ph : 2226-9909,
                                18003453375 (Toll Free)
                              </p>
                            </td>
                          </tr>
                          <tr>
                            {/* <td>
                              <strong> {t("WhatsApp")} -</strong>
                              <p className="fontSizeClass">
                                {t("Ph")}:8335988888
                              </p>
                            </td> */}
                            <td>
                              <strong> {t("CHATBOT")} -</strong>
                              <p className="fontSizeClass">
                                {t("Ph")}:8335999111
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact_Us_Home;
